<template>
  <div>
    <b-row>
      <b-col cols="12" md="12" class="mb-3">
        <Search
          :title="$lang.final_report_education"
          :url="educationUrl"
          :allowFields="$lang.final_report_votes_education_fields"
          :visibleAdd="false"
          :allowOperate="false"
          :showFilterBtn="false"
          :visibleSettings="false"
          :visibleExport="false"
          :dataNotExist="$lang.notRecordExist"
        />
      </b-col>
      <b-col cols="12" md="12" class="mb-3">
        <Search
          :title="$lang.final_report_votes_courses_title"
          :url="coursesUrl"
          :allowFields="$lang.final_report_votes_courses_fields"
          :visibleAdd="false"
          :allowOperate="false"
          :showFilterBtn="false"
          :visibleSettings="false"
          :visibleExport="false"
          :dataNotExist="$lang.notRecordExist"
        />
      </b-col>
      <b-col cols="12" md="12" class="mb-3">
        <Search
          :title="$lang.final_report_votes_article_title"
          :url="articleUrl"
          :allowFields="$lang.final_report_votes_article_fields"
          :visibleAdd="false"
          :allowOperate="false"
          :showFilterBtn="false"
          :visibleSettings="false"
          :visibleExport="false"
          :dataNotExist="$lang.notRecordExist"
        />
      </b-col>
    </b-row>
  </div>
</template>
<script>
import Search from "@/components/base/search";

export default {
  components: {
    Search,
  },
  props: {
    personCode: {
      type: [String, Number],
      default: null,
    },
  },
  data() {
    return {
      code: this.$route.params.code,
    };
  },
  computed: {
    educationUrl() {
      // check requirement
      if (!this.personCode) {
        return null;
      }

      return (
        this.$config.api_url +
        this.$config.profile.person_education.replace("{0}", this.personCode)
      );
    },
    coursesUrl() {
      // check requirement
      if (!this.personCode) {
        return null;
      }

      return (
        this.$config.api_url +
        this.$config.profile.peron_free_course.replace("{0}", this.personCode)
      );
    },
    articleUrl() {
      // check requirement
      if (!this.personCode) {
        return null;
      }

      return (
        this.$config.api_url +
        this.$config.profile.person_article.replace("{0}", this.personCode)
      );
    },
  },
};
</script>